import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DriverPage from './DriverPage';
import { Helmet } from 'react-helmet';
import { FiCheckCircle } from 'react-icons/fi';

const TripCompletedPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/driver-dashboard');
        }, 5000);
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <DriverPage>
            <Helmet>
                <title>Trip Completed | Storage Sprint</title>
            </Helmet>

            <div className="min-h-screen bg-gray-50 px-4 py-10 md:py-16">
                <div className="max-w-xl mx-auto bg-white shadow-md rounded-xl p-6 md:p-10 text-center">
                    <FiCheckCircle className="text-yellow-500 mx-auto mb-4" size={48} />
                    <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
                        Trip <span className="text-yellow-500">Completed</span> Successfully!
                    </h1>
                    <p className="text-gray-600 mb-6">
                        Great job! You've successfully completed the trip.
                    </p>
                    <p className="text-gray-600">
                        You'll be redirected to your dashboard shortly.
                    </p>
                </div>
            </div>
        </DriverPage>
    );
};

export default TripCompletedPage;
